import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";

export default createStore({
    state: {
        common: {
            corpCode : '1011',
            corp: '10',
            brch: '11',
            corpName: ''
        }
    },
    mutations: {
        updateCorpCode(state, corpData){
            if (corpData.detail.length >= 4) {
                state.common.corpCode = corpData.detail
                state.common.corp = corpData.detail.substring(0,2)
                state.common.brch = corpData.detail.substring(2,4)
                state.common.corpName = corpData.detail_name
            }
        },
        removeCorpCode(state) {
            state.common = {
                corpCode : '',
                corp: '',
                brch: '',
                corpName: ''
            }
        },
    },
    getters: {

    },
    actions: {
        setCorpCode: ({commit}, corpData) => {
            commit('removeCorpCode');
            commit('updateCorpCode', corpData);
        }
    },
    modules: {},
    plugins: [
        createPersistedState()
    ]
})